import { useCategories } from 'api/categoryApi';
import { StyledSelect } from 'styles/overrides';
import _ from 'lodash';
import { filterOptions } from 'utils/formatUtils';
import { useCustomSearchParams } from 'hooks/useCustomSearchParams';

export default function UserSelector({
  onChange,
  value,
  params = {},
  ...restProps
}) {
  const [search] = useCustomSearchParams();
  const { data = [], isLoading } = useCategories({
    params: {
      page_size: 1000,
      ...params,
      locale_code: params?.locale_code || _.get(search, ['locale_code']),
    },
    options: {
      select: (response) =>
        _.map(response?.data, ({ id, name }) => ({
          label: name,
          value: id.toString(),
        })) ?? [],
    },
  });

  return (
    <StyledSelect
      options={data}
      loading={isLoading}
      showSearch
      optionFilterProp="label"
      filterOption={filterOptions}
      {...restProps}
      onChange={onChange}
      value={value}
    />
  );
}
